<template>
  <section class="relative px-4 mb:px-[44px]">
    <div class="max-w-[1920px] p-4 md:px-[60px] lg:px-8 xl:px-[80px] 2xl:px-[120px] mx-auto rounded-[40px] flex flex-col justify-between w-full bg-cover bg-no-repeat h-[962px] px-[18px] md:px-[75px] pb-[50px] mb:pb-[100px] pt-6" :style="{backgroundImage: `url(${isMobile ? heroMobileBgImagePath : heroBgImagePath})`}">
      <div class="flex-grow-0 flex-shrink-0 flex justify-center w-full">
        <Paw class="w-[38px] md:w-[57px]" />
        <button class="text-[15px] md:text-[22px] py-2 px-4 text-white font-[400] border border-solid border-white rounded-[100px]">
          {{ t('home.hero.pets') }}
        </button>
        <Dog class="w-[38px] md:w-[57px]" />
        <Cat class="w-[38px] md:w-[57px]" />
        <Rabbit class="w-[38px] md:w-[57px]" />
        <Bird class="w-[38px] md:w-[57px]" />
      </div>
      <div class="flex-grow w-full flex flex-col md:flex-row space-y-[60px] md:space-y-0 md:justify-between justify-end md:items-end">
        <div class="text-center md:text-left z-10 mb-[200px] md:pb-[100px]">
          <h1 class="text-[56px] md:text-[70px] lg:text-[90px] xl:text-[120px] font-bold text-white leading-none font-Comfortaa md:pb-2 text-center md:text-left">
            {{ t('home.hero.title') }}
          </h1>
          <h3 class="text-[22px] sm:text-[30px] md:text-[35px] xl:text-[44px] font-[400] xl:max-w-[909px] leading-none text-white pb-8 md:pb-[60px] ">
            {{ t('home.hero.subtitle') }}
          </h3>
          <VaButton
            :to="{ name: 'products' }"
            color="pink-500"
            round
          >
            <span class="flex py-2 px-[34px] items-center">
              <span class="text-[16px] md:text-[20px] whitespace-nowrap text-white font-medium">{{ t('home.hero.ourProducts') }}</span>
              <Frama />
            </span>
          </VaButton>
        </div>
        <div class="justify-items-end lg:justify-items-normal">
          <div class="relative w-[93px] h-auto sm:w-[150px] xl:w-full">
            <img src="@/assets/images/animals.png" alt="pets" />
            <Play class="absolute left-[-14px] top-[-14px] sm:left-[-18px] sm:top-[-18px] xl:left-[-22px] xl:top-[-22px] w-[24px] sm:w-[35px] xl:w-[44px]" />
          </div>
        </div>
        <Foot class="absolute left-[-88px] bottom-[-91px] md:block hidden" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import heroMobileBgImagePath from '@/assets/images/home-hero-mobile.png'
import heroBgImagePath from '@/assets/images/home-hero.png'
import Dog from '@/assets/icons/menu/dog.svg'
import Foot from '@/assets/images/foot.svg'
import Play from '@/assets/icons/menu/play.svg'
import Frama from '@/assets/icons/menu/frama.svg'
import Bird from '@/assets/icons/menu/bird.svg'
import { VaButton } from 'vuestic-ui'
import Paw from '@/assets/icons/menu/paw.svg'
import Cat from '@/assets/icons/menu/cat.svg'
import Rabbit from '@/assets/icons/menu/rabbit.svg'
import { useI18n } from 'vue-i18n'
import { useIsMobile } from '@/composables/Mobile'

const { isMobile } = useIsMobile()
const { t } = useI18n()
</script>
